import React, { useEffect, useRef, useState } from 'react';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import { useClientApiFetch } from 'ts/client/common/hooks';
import ClientInvoiceOverview from 'ts/common/components/invoice/ClientInvoiceOverview';
import { FetchMethod } from 'ts/common/hooks';
import PaymentConfirmationModal from 'client_react/invoice/components/PaymentConfirmationModal';

const InvoiceLandingPage: React.FC = () => {
    const { invoice, refetchInvoice } =
        useOutletContext<{ invoice: SpApi.Client.IInvoice; refetchInvoice: () => Promise<void> }>();
    const [searchParams, setSearchParams] = useSearchParams();
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const hasShownModalRef = useRef(false);

    useEffect(() => {
        scrollTo(0, 0);

        // Check if payment was successful and there's a confirmation message to show
        // Only show the modal once per session using the ref to prevent reopening on invoice refetch
        if (
            searchParams.get('payment') === 'success' &&
            invoice.paymentConfirmationText &&
            !hasShownModalRef.current
        ) {
            setIsConfirmationModalOpen(true);
            hasShownModalRef.current = true;
            // Remove the payment parameter from URL
            searchParams.delete('payment');
            setSearchParams(searchParams, { replace: true });
        }
    }, [searchParams, setSearchParams, invoice.paymentConfirmationText]);

    const { performFetch: removeSavedCard } = useClientApiFetch<void>(
        `brand/${invoice.brand.id}/invoice/${invoice.publicId}/credit-card`,
        {
            defer: true,
            method: FetchMethod.DELETE
        }
    );

    const onRemoveSavedCard = async () => {
        const response = await removeSavedCard();
        await refetchInvoice();
        return response;
    };

    const handleCloseConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };

    return (
        <>
            <ClientInvoiceOverview invoice={invoice} onRemoveSavedCard={onRemoveSavedCard} />
            <PaymentConfirmationModal
                isOpen={isConfirmationModalOpen}
                onClose={handleCloseConfirmationModal}
                invoice={invoice}
            />
        </>
    );
};

export default InvoiceLandingPage;
